import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Card, ListGroup, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import FeedCardFooter from './FeedCardFooter';
import FeedCardHeaderInfiniteScroll from './FeedCardHeaderInfiniteScroll';
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from 'react-loading-skeleton'

const FeedCardInfiniteScroll = ({
    comentarios,
    setComentarios,
    submitComment,
    comentario,
    setComentario,
    procesandoComentario,
    idUsuario,
    obtenerComentarios,
    hayMasComentarios,
    cargandoComentarios,
    token,
    setToken

}) => {
    const [procesandoEdicion, setProcesandoEdicion] = useState(false);
    /**
     * Edita un comentario existente
     */
    const handleEditComment = async (idLeadComentario, comentarioActual) => {
        const body = JSON.stringify({
            idLeadComentario,
            comentario: comentarioActual,
            idUsuario
        });
        console.log(body)
        setProcesandoEdicion(true);

        try {
            const response = await fetch("/api/leads/editarComentario",
                {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    },
                    body
                })
                .catch((error) => {
                    console.log('Hubo un problema con la peticion Fetch:' + error);
                    setProcesandoEdicion(false);
                    throw error;
                });

            if (response.ok) {
                console.log("==== EDITAR COMENTARIO ====");
                const data = await response.json();

                if (data.iResponseType == 1) {

                    const detalles = JSON.parse(data.detalles);
                    const actualizado = detalles.table2 && detalles.table2[0] ? detalles.table2[0] : null;
                    console.log('Comentario actualizado:', actualizado);
                    if (actualizado) {
                        setComentarios(prevComentarios =>
                            prevComentarios.map(comentario =>
                                comentario.idLeadComentario === idLeadComentario
                                    ? {
                                        ...comentario,
                                        vComentario: actualizado.vComentario,
                                        vIP: actualizado.vIP,
                                        dUpdatedDate: actualizado.dUpdatedDate,
                                        idTipoComentario: actualizado.idTipoComentario,
                                        idLead: actualizado.idLead
                                    }
                                    : comentario
                            )
                        );
                    }
                    console.log("Comentario editado exitosamente");
                } else {
                    console.log("Error al editar comentario:", data.vMessage);
                }
                setProcesandoEdicion(false);
                setProcesandoEdicion(false);
            } else {
                setProcesandoEdicion(false);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                console.log("Error en la respuesta:", response.status, response.statusText);
            }
        } catch (error) {
            setProcesandoEdicion(false);
            console.log("Error al editar comentario:", error);
        }
    };


    return (
        <Card >
            <FeedCardFooter
                submitComment={submitComment}
                comentario={comentario}
                setComentario={setComentario}
                procesandoComentario={procesandoComentario}
                idUsuario={idUsuario}
            />
            {
                cargandoComentarios ?
                    <ComentarioSkeleton />
                    :
                    <>
                        <span className="pb-2" >

                            {
                                <ListGroup id={"comentarios"} variant="flush" className="fw-normal fs--1 scrollbar" style={{ maxHeight: '25rem' }}>

                                    <InfiniteScroll
                                        dataLength={comentarios ? comentarios.length : 0}
                                        next={() => obtenerComentarios()}
                                        hasMore={hayMasComentarios == 1 ? true : false}
                                        loader={<ComentarioSkeleton />}
                                        scrollableTarget={"comentarios"}
                                        scrollThreshold={0.8}
                                    >

                                        {comentarios &&
                                            comentarios.map(
                                                (c, i) => (
                                                    <FeedCardHeaderInfiniteScroll
                                                        key={i}
                                                        vNombreUsuario={c.vNombreUsuario}
                                                        vComentario={c.vComentario}
                                                        idTipoComentario={c.idTipoComentario}
                                                        vFecha={c.vFecha}
                                                        vHora={c.vHora}
                                                        vIP={c.vIP}
                                                        idUsuario={Number(c.idUsuario)}
                                                        comentarioExtra={c.vComentarioExtra}
                                                        idTipoComentarioExtra={c.idTipoComentarioExtra}
                                                        idOrden={c.idOrden}
                                                        idLicencia={c.idLicencia}
                                                        idLeadComentario={c.idLeadComentario}
                                                        onEditComment={handleEditComment}
                                                        currentUserId={idUsuario}
                                                        procesandoEdicion={procesandoEdicion}
                                                        dUpdatedDate={c.dUpdatedDate}
                                                    />

                                                )
                                            )
                                        }

                                    </InfiniteScroll>
                                </ListGroup>
                            }
                        </span>
                    </>
            }


        </Card>
    );
};

const ComentarioSkeleton = () => {
    return (
        <>

            <Row
                style={{ border: 'none' }}
                className={classNames(
                    'p-1 shadow-none  d-flex align-items-center rounded-0',
                    'notification-skeleton'
                )}
            >
                <Col className="col-1 pe-0">
                    <Skeleton circle width={30} height={30} />
                </Col>
                <Col className="col-11 ">
                    <Skeleton height={30} width="100%" />
                </Col>
            </Row>

        </>

    );
};

FeedCardInfiniteScroll.propTypes = {
    comentarios: PropTypes.array,
    setComentarios: PropTypes.func,
    submitComment: PropTypes.func,
    comentario: PropTypes.string,
    setComentario: PropTypes.func,
    procesandoComentario: PropTypes.bool,
    idUsuario: PropTypes.number,
    obtenerComentarios: PropTypes.func,
    hayMasComentarios: PropTypes.number,
    cargandoComentarios: PropTypes.bool,
    token: PropTypes.string,
    setToken: PropTypes.func
};

export default FeedCardInfiniteScroll;
